module.exports = require("./ff-Latn-GH.js");